import { useCallback, useState } from 'react';
import { handleMultiSelectChange } from 'util/multi-select';

export const useOnAutocompleteChange = (
  onChange,
  multiple,
  options,
  valueGetter = option => option.id,
  handleAdditionalLogicBeforeOnChange,
  withSelectAllOption = false,
) =>
  useCallback(
    (_e, option, reason) => {
      let value;
      if (multiple && withSelectAllOption)
        value = handleMultiSelectChange(option, options);
      else if (multiple)
        value = option.map(option => valueGetter(option) ?? option);
      else if (reason === 'clear') value = '';
      else value = valueGetter(option);
      handleAdditionalLogicBeforeOnChange?.(option);
      onChange(value);
    },
    [
      multiple,
      withSelectAllOption,
      options,
      valueGetter,
      handleAdditionalLogicBeforeOnChange,
      onChange,
    ],
  );

export const useRetainAutocompleteInputValue = () => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (_e, newValue, reason) => {
    if (['reset', 'selectOption'].includes(reason)) return;
    setInputValue(newValue);
  };

  return {
    inputValue,
    handleInputChange,
  };
};
